import { render, staticRenderFns } from "./authorAll.vue?vue&type=template&id=aaf1513a&"
import script from "./authorAll.vue?vue&type=script&lang=js&"
export * from "./authorAll.vue?vue&type=script&lang=js&"
import style0 from "./authorAll.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports